<ion-row>
  <ion-col>
    <a href="/" aria-label="Hubgrade-Startseite">
      <ion-img class="app-logo" src="assets/app-logo-v1-0-0.svg" alt="Hubgrade Logo"></ion-img>
    </a>
  </ion-col>
</ion-row>
